<template>
    <SideHeader :indexPage="true"/>

  <!-- App Capsule -->
  <div style="padding-top: 55px;">
    <div class="login-form mt-5">
      <div class="section">
        <h1>لطفا کد تایید وارد کنید</h1>
        <h4>
          ما یک کد تأیید بر روی تلفن شما {{ data.mobileNumber }} ارسال کردیم
        </h4>
      </div>

      <div class="section mt-2 mb-5">
        <form @submit.prevent="verifyCode()">
          <div class="form-group boxed">
            <div class="input-wrapper">
              <input
                type="tel"
                class="form-control verify-input"
                v-model="data.code"
                id="smscode"
                placeholder="•••••"
                maxlength="5"
                autofocus
              />
            </div>
          </div>
          <a class="btn btn-link" href="/">شماره موبایل اشتباه وارد کرده اید؟</a>

          <div class="form-button-group">
            <button
              v-if="loading == false"
              type="submit"
              class="btn background-ORANGE text-light btn-block btn-lg"
            >
              تایید
            </button>
            <button
              v-else
              class="btn background-ORANGE text-light btn-block btn-lg"
              type="button"
              disabled
            >
              <span
                class="spinner-border spinner-border-sm me-05"
                role="status"
                aria-hidden="true"
              ></span>
              درحال بررسی ...
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
  <!-- * App Capsule -->
</template>
<script>
import SideHeader from "@/components/SideHeader.vue";
import axios from "axios";
import Swal from "sweetalert2";

export default {
  components:{
    SideHeader
  },
  data() {
    return {
      data: {
        mobileNumber: this.$route.params.mobileNumber,
        code: "",
      },
      loading: false,
    };
  },
  methods: {
    verifyCode() {
      this.loading = true;
      axios
        .post(
          "https://core.iran-tarabar.ir/api/verifyActivationCodeForDriver",
          this.data
        )
        .then((response) => {
          // console.log(response);
          this.loading = false;
          if (response.data.result == 1) {
            localStorage.setItem("token", response.data.token);
            localStorage.setItem("idUser", response.data.id);
            window.location.href = "/";
          }
          if (response.data.result == 0) {
            // this.$router.replace({ name: "register", params: { mobileNumber: this.$route.params.mobileNumber } })
            console.log(response);
            Swal.fire({
              position: "top-end",
              icon: "error",
              title: response.data.message,
              showConfirmButton: false,
              timer: 2000,
            });
          }
          if (response.data.result == 2) {
            this.$router.replace({
              name: "register",
              params: { mobileNumber: this.$route.params.mobileNumber },
            });
          }
        });
    },
  },
};
</script>
<style></style>